module.exports = __webpack_public_path__ + "media/images/plans/plan-photo-4-5a50fe7ce0e58d062ea293e20f7a672b.png";